import {
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@mui/material';
import Accordion from 'components/Accordion';
import { useTranslation } from 'react-i18next';

export default function SexFilter({ setFilters, filters, defaultExpanded = false }) {
  const { t } = useTranslation();
  const { gender } = filters;
  const sexList = [
    { value: 'MALE', label: t('Male') },
    { value: 'FEMALE', label: t('Female') },
    { value: 'OTHER', label: t('Other') },
  ];

  const setGenderFilters = (genderName) => {
    const isPresent = !!gender.find((item) => item === genderName);

    if (isPresent) {
      setFilters({
        ...filters,
        gender: gender.filter((item) => item !== genderName),
      });
    } else {
      setFilters({
        ...filters,
        gender: [...gender, genderName],
      });
    }
  };

  return (
    <Accordion title={t('Sex')} defaultExpanded={defaultExpanded}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {sexList.map((item) => (
          <MuiFormControlLabel
            key={item.value}
            control={
              <MuiCheckbox
                checked={!!gender.find((gender) => gender === item.value)}
                onClick={() => setGenderFilters(item.value)}
              />
            }
            label={item.label}
          />
        ))}
      </div>
    </Accordion>
  );
}
